import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronLeftIcon } from 'lucide-react';
const PrivacyPolicy = () => {
  return <div className="bg-[#0F1115] min-h-screen relative" data-id="element-1779">
      {/* Global Grain Texture */}
      <div className="absolute inset-0 opacity-[0.03] pointer-events-none z-50 bg-grain mix-blend-overlay" data-id="element-1780"></div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10" data-id="element-1781">
        <div className="max-w-3xl mx-auto" data-id="element-1782">
          <Link to="/" className="inline-flex items-center text-gray-400 hover:text-white transition-colors mb-8" data-id="element-1783">
            <ChevronLeftIcon className="w-5 h-5 mr-1" data-id="element-1784" />
            Back to Home
          </Link>

          <h1 className="text-4xl font-bold text-white mb-4" data-id="element-1785">Privacy Policy</h1>
          <div className="text-sm text-gray-500 mb-8" data-id="element-1786">
            Last updated: June 1, 2023
          </div>

          <div className="prose prose-lg prose-invert max-w-none" data-id="element-1787">
            <div className="text-gray-300 space-y-6" data-id="element-1788">
              <p data-id="element-1789">
                At CertifiedDevs, we take your privacy seriously. This Privacy
                Policy explains how we collect, use, disclose, and safeguard
                your information when you visit our website and use our
                services.
              </p>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1790">
                Information We Collect
              </h2>
              <p data-id="element-1791">
                We collect information that you provide directly to us when you
                register for an account, create or modify your profile, set
                preferences, or make purchases through the Services.
              </p>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3" data-id="element-1792">
                Personal Information
              </h3>
              <p data-id="element-1793">When you register for an account, we may collect:</p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1794">
                <li data-id="element-1795">Your name, email address, and contact information</li>
                <li data-id="element-1796">
                  Profile information such as your photo, bio, skills, and
                  location
                </li>
                <li data-id="element-1797">Payment information for transactions</li>
                <li data-id="element-1798">Communications you send to us</li>
              </ul>

              <h3 className="text-xl font-semibold text-white mt-6 mb-3" data-id="element-1799">
                Automatically Collected Information
              </h3>
              <p data-id="element-1800">
                When you access or use our Services, we automatically collect:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1801">
                <li data-id="element-1802">
                  Log information (IP address, browser type, pages visited)
                </li>
                <li data-id="element-1803">Device information</li>
                <li data-id="element-1804">Location information</li>
                <li data-id="element-1805">Cookie data</li>
              </ul>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1806">
                How We Use Your Information
              </h2>
              <p data-id="element-1807">
                We may use the information we collect for various purposes,
                including to:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1808">
                <li data-id="element-1809">Provide, maintain, and improve our Services</li>
                <li data-id="element-1810">Process transactions and send related information</li>
                <li data-id="element-1811">
                  Send technical notices, updates, security alerts, and support
                  messages
                </li>
                <li data-id="element-1812">Respond to your comments, questions, and requests</li>
                <li data-id="element-1813">
                  Communicate with you about products, services, offers, and
                  events
                </li>
                <li data-id="element-1814">Monitor and analyze trends, usage, and activities</li>
                <li data-id="element-1815">
                  Detect, investigate, and prevent fraudulent transactions and
                  other illegal activities
                </li>
                <li data-id="element-1816">
                  Personalize the Services and provide advertisements, content,
                  or features that match user profiles or interests
                </li>
              </ul>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1817">
                Sharing of Information
              </h2>
              <p data-id="element-1818">
                We may share the information we collect in various ways,
                including:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1819">
                <li data-id="element-1820">
                  With vendors, consultants, and other service providers who
                  need access to such information to carry out work on our
                  behalf
                </li>
                <li data-id="element-1821">
                  In response to a request for information if we believe
                  disclosure is in accordance with, or required by, any
                  applicable law, regulation, or legal process
                </li>
                <li data-id="element-1822">
                  If we believe your actions are inconsistent with our user
                  agreements or policies, or to protect the rights, property,
                  and safety of CertifiedDevs or others
                </li>
                <li data-id="element-1823">
                  In connection with, or during negotiations of, any merger,
                  sale of company assets, financing, or acquisition of all or a
                  portion of our business by another company
                </li>
                <li data-id="element-1824">With your consent or at your direction</li>
              </ul>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1825">
                Your Choices
              </h2>
              <p data-id="element-1826">
                You have several choices regarding the information we collect
                and how it is used:
              </p>
              <ul className="list-disc pl-6 space-y-2" data-id="element-1827">
                <li data-id="element-1828">
                  Account Information: You may update, correct, or delete your
                  account information at any time by logging into your account
                </li>
                <li data-id="element-1829">
                  Cookies: Most web browsers are set to accept cookies by
                  default. If you prefer, you can usually choose to set your
                  browser to remove or reject cookies
                </li>
                <li data-id="element-1830">
                  Promotional Communications: You may opt out of receiving
                  promotional communications from us by following the
                  instructions in those communications
                </li>
              </ul>

              <h2 className="text-2xl font-bold text-white mt-8 mb-4" data-id="element-1831">
                Contact Us
              </h2>
              <p data-id="element-1832">
                If you have any questions about this Privacy Policy, please
                contact us at:
              </p>
              <p data-id="element-1833">
                Email: privacy@certifieddevs.com
                <br data-id="element-1834" />
                Address: Keizersgracht 241, 1016 EA Amsterdam, Netherlands
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default PrivacyPolicy;